import { envs } from '@config';

import { datadogLogs } from './dd-logs';
import { Hermes } from './hermes';

const createLoggerInstance = () =>
  envs.isDevelopment ? console : datadogLogs.logger;

export default new Hermes(createLoggerInstance());
